<template>
	<auth-layout>
		<v-responsive min-height="100vh" class="d-flex align-center" slot="content">
			<main-container centered>
				<ValidationObserver ref="observer" v-slot="{ failed }">
					<material-card class="px-5 py-3" max-width="400" color="white">
						<v-img :src="$appOptions.systemLogo()" slot="image">
							<template v-slot:placeholder>
								<v-sheet>
									<v-skeleton-loader type="image"></v-skeleton-loader>
								</v-sheet>
							</template>
						</v-img>
						<div slot="after-heading">
							{{ $t("user.setnewpassword") }}
						</div>
						<span>{{ $t("user.setnewpasswordmessage") }}</span>
						<v-form ref="passwordReset" flat>
							<v-text-field v-model="user.email" type="email" autocomplete="email" class="hidden"></v-text-field>
							<v-row dense>
								<v-col cols="12" xs="12">
									<ValidationProvider vid="password" :name="$t('user.newpassword')" rules="required|min:6" v-slot="{ errors, field }">
										<v-text-field class="required" :label="$t('user.newpassword')" @keydown.space.prevent v-model="user.password" :error-messages="errors" type="password" @change="resetValidator" @input="updateStrength" autocomplete="new-password" ref="actualpassword">
											<v-progress-circular slot="append-outer" size="50" :rotate="90" :value="score" :color="scoreColor">{{ displayedScore }}</v-progress-circular>
										</v-text-field>
									</ValidationProvider>
									<span class="text-caption" :class="scoreColor + '--text'" v-if="user.password">{{ scoreMessage }}</span>
								</v-col>
								<v-col cols="12" xs="12">
									<ValidationProvider vid="password" :name="$t('user.password_confirmation')" rules="required|min:6" v-slot="{ errors, field }">
										<v-text-field class="required" @keyup.enter="resetPassword()" @keydown.space.prevent :label="$t('user.password_confirmation')" v-model="user.password_confirmation" :error-messages="errors" type="password" @change="resetValidator" autocomplete="new-password"></v-text-field>
									</ValidationProvider>
								</v-col>
							</v-row>
						</v-form>
						<template slot="actions">
							<v-col cols="6" xs="6">
								<action-button @click="login()" outlined block :disabled="is_authloading" :text="$t('user.login')"></action-button>
							</v-col>
							<v-col cols="6" xs="6">
								<action-button color="success" @click="resetPassword()" block :loading="is_authloading" :disabled="failed" :text="$t('global.confirm')"></action-button>
							</v-col>
						</template>
					</material-card>
				</ValidationObserver>
			</main-container>
		</v-responsive>
	</auth-layout>
</template>

<script>
export default {
	data: () => ({
		score: 0,
		user: {
			email: null,
			password: "",
			password_confirmation: "",
			token: null,
		},
	}),
	computed: {
		displayedScore() {
			return Math.floor(this.score / 10);
		},
		scoreMessage() {
			return this.$functions.passwordScoreMessage(this.displayedScore);
		},
		scoreColor() {
			return this.$functions.passwordScoreColor(this.displayedScore);
		},
		authError() {
			return this.$store.getters.getAuthError;
		},
		is_authloading() {
			return this.$store.getters.is_authloading;
		},
		apierrors() {
			return this.$store.getters.getApiErrors;
		},
	},
	methods: {
		resetValidator() {
			this.$refs.observer.reset();
		},
		updateStrength(password) {
			this.score = this.$functions.checkPassword(password);
		},
		resetPassword() {
			const self = this;
			this.$refs.observer.validate().then((isValid) => {
				if (isValid == true) {
					this.$store.dispatch("resetPassword", this.user).then((res) => {
						if (res.message) {
							this.$router.push("/");
						}
					});
				}
			});
		},
		login() {
			const self = this;
			self.$router.push({
				path: "/",
			});
		},
	},
	watch: {
		apierrors: {
			handler: function (val) {
				this.$functions.ApiErrorsWatcher(val, this.$refs.observer);
			},
			deep: true,
		},
	},
	mounted() {
		let $wrong = false;
		if (this.$route.query) {
			this.user.email = this.$route.query.email;
			this.user.token = this.$route.query.token;
		} else {
			$wrong = true;
		}
		if ($wrong == true) {
			this.$store.commit("authError", "malformed_link");
		}
	},
	beforeCreate() {
		if (this.$store.getters.isAuthenticated) {
			this.$store.dispatch("logout");
		}
	},
};
</script>
